import setup from '../assets/data/setup.json';

function JsonLd() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: setup.profile.name,
    jobTitle: setup.profile.title,
    url: setup.profile.siteUrl,
    email: setup.profile.email,
    sameAs: [setup.profile.github, setup.profile.linkedin],
    knowsAbout: [
      'Enterprise Software',
      'SaaS Development',
      'ERP Systems',
      'Cloud Infrastructure',
      'AI Applications',
      'Workflow Automation',
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export default JsonLd;
